import { useCallback } from 'react';

export default function useOcrExtractor() {
  const extractInfoFromText = useCallback((text) => {
    const lines = text
      .split(/\n+/)
      .map(line => line.trim())
      .filter(Boolean);

    let devEui = '';
    let serialNumber = '';
    let model = '';
    let fccId = '';
    let sku = '';

    for (let rawLine of lines) {
      let line = rawLine
        .replace(/[|€@®©™]/g, '')        // remove OCR garbage
        .replace(/\s{2,}/g, ' ')         // collapse multiple spaces
        .trim();

      if (!line || line.length < 4) continue;

      // ---- DevEUI detection ----
      if (!devEui) {
        const labeled = line.match(/DevEUI[:\s]*([a-f0-9]{16})/i);
        if (labeled) {
          devEui = labeled[1].toUpperCase();
          continue;
        }

        // const loose = line.match(/\b([a-f0-9]{16})\b/i);
        // if (loose && !/sn[:\s]*/i.test(line)) {
        //   devEui = loose[1].toUpperCase();
        //   continue;
        // }

        const maybeHex = line.replace(/[^a-f0-9]/gi, '').toUpperCase();
        if (
            maybeHex.length === 16 &&
            /^[A-F0-9]{16}$/i.test(maybeHex) &&
            !/SN[:\s]*/i.test(line)
        ) {
            devEui = maybeHex;
            continue;
        }
      }

      // ---- Serial Number detection ----
      if (!serialNumber) {
        const snMatch = line.match(/SN[:\s]*([a-z0-9\-]+)/i);
        if (snMatch) {
          serialNumber = snMatch[1].toUpperCase();
          continue;
        }
      }

      // ---- Model detection ----
      if (!model) {
        const modelMatch = line.match(/Model[:\s\-]*([A-Z0-9\-]+)/i);
        if (modelMatch) {
          model = modelMatch[1].toUpperCase();
          continue;
        }
      }

      // ---- FCC ID detection ----
      if (!fccId) {
        const fccMatch = line.match(/FCC[:\s\-]*ID[:\s\-]*([A-Z0-9\-]+)/i);
        if (fccMatch) {
          fccId = fccMatch[1].toUpperCase();
          continue;
        }
      }
      if (!sku) {
        const skuMatch = line.match(/SKU[:\s\-]*([A-Z0-9\-]+)/i);
        if (skuMatch) {
          sku = skuMatch[1].toUpperCase();
          continue;
        }
      }
    }

    return { devEui, serialNumber, model, fccId, sku };
  }, []);

  return extractInfoFromText;
}
